var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tutorials" }, [
    _c("div", { staticClass: "container" }, [
      _c("p", { staticClass: "black mg mg--b-2 headline-large" }, [
        _vm._v(_vm._s(_vm.$t("tutorials.title")))
      ]),
      _c(
        "ul",
        { staticClass: "list-tutorials" },
        [
          _vm._l(_vm.tutorialsData, function(tutorial) {
            return _c(
              "li",
              {
                staticClass: "mg",
                on: {
                  click: function($event) {
                    return _vm.handleOpenModal(tutorial.url, tutorial.title)
                  }
                }
              },
              [
                _c(
                  "p",
                  { staticClass: "white headline-large tutorial-title" },
                  [_vm._v(_vm._s(tutorial.title))]
                )
              ]
            )
          }),
          _c(
            "ma-modal",
            {
              ref: "videoModal",
              staticClass: "modal-video",
              attrs: { type: "small" }
            },
            [
              _c("template", { slot: "modalContent" }, [
                _c("div", { staticClass: "modal__main" }, [
                  _c("div", { staticClass: "container-content_modal" }, [
                    _c(
                      "p",
                      { staticClass: "black headline-large black mg mg--b-7" },
                      [_vm._v(_vm._s(_vm.titleVideo))]
                    ),
                    _c(
                      "video",
                      {
                        ref: "videoTutorial",
                        staticClass: "video-tutorial",
                        attrs: { controls: "" }
                      },
                      [
                        _c("source", {
                          attrs: { src: _vm.urlVideo, type: "video/mp4" }
                        })
                      ]
                    )
                  ])
                ])
              ])
            ],
            2
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }